import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { PACKAGES_VOLUME_CHART_ENDPOINT } from '../package-chart-endpoints';

export const LENDING_RETURN_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.LENDING_RETURN_PACKAGE_VOLUME_HOUR_DAY_HEATMAP,
    chartType: ChartRendererType.HEATMAP,
    endpoint: PACKAGES_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.LENDING },
        { key: ChartQueryParam.FEATURE, value: Feature.RETURN_TRANSACTION },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.HOUR }
    ]
};
